<template>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 align-items-center">
            <div class="card card-primary card-outline">
                <div class="card-body box-profile">
                    <div class="text-center">
                        <img class="profile-user-img img-fluid img-circle" src="images/user.png" alt="User profile picture">
                    </div>
                    <hr>
                    <div >
                        <template v-if="is_student">
                            <h3 class="profile-username text-center">{{ std_admission_details.Name }}</h3>
                        </template>
                        <template v-else>
                            <h3 class="profile-username text-center">{{ name }}</h3>
                        </template>
                        <ul class="list-group list-group-unbordered mb-3">
                            <template v-if="is_student">
                                <li class="list-group-item">
                                <b>Full Name</b><a class="float-right">{{ std_admission_details.Name}}</a>
                            </li>
                            </template>
                            <template v-else>
                                <li class="list-group-item">
                                <b>Full Name</b><a class="float-right">{{ name }}</a>
                            </li>
                            </template>
                            <!-- displaying for email and student code  -->
                            <template v-if="is_student">
                                <li class="list-group-item">
                                <b>Student Code</b><a class="float-right">{{ std_admission_details.student_code}}</a>
                            </li>
                            </template>
                            <template v-else>
                                <li class="list-group-item">
                                <b>Email Address</b><a class="float-right">{{ email }}</a>
                            </li>
                            </template>
                            <!-- contact number -->
                            <template v-if="is_student">
                                <li class="list-group-item">
                                <b>Contact Number</b><a class="float-right">{{ std_admission_details.Std_contact}}</a>
                            </li>
                            </template>
                            <template v-else>
                                <li class="list-group-item">
                                <b>Contact Number</b><a class="float-right">{{ contact }}</a>
                            </li>
                            </template>
                            <template v-if="is_student">
                                <li class="list-group-item">
                                    <b>CID No</b> <a class="float-right">{{std_admission_details.CidNo}}</a>
                                </li>
                            </template>
                            <template v-else>
                                <li class="list-group-item">
                                    <b>User Type</b> <a class="float-right">{{ type }}</a>
                                </li>
                            </template>
                            <template v-if="is_student">
                                <li class="list-group-item">
                                    <b>Date of Birth</b> <a class="float-right">{{ std_admission_details.DateOfBirth }}</a>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6" v-if="is_student">
            <div class="row form-group card card-primary card-outline">
                <div class="card-header p-0 border-bottom-0 nav nav-pills flex-column flex-sm-row">
                    <ul class="nav nav-tabs border-primary" id="custom-tabs-four-tab" role="tablist">
                        <li class="nav-item border-left border-right">
                            <a class="nav-link active" id="parents_tab-tab" data-toggle="pill" href="#parents_tab" role="tab" aria-controls="parents_tab" aria-selected="false" style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Parents Details</a>
                        </li>
                        <li class="nav-item border-left border-right">
                            <a class="nav-link" id="roles-tab" data-toggle="pill" href="#roles" role="tab" aria-controls="roles" aria-selected="false" style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Roles & Responsibilities</a>
                        </li>
                        <li class="nav-item border-left border-right">
                            <a class="nav-link" id="programmes-tab" data-toggle="pill" href="#programmes" role="tab" aria-controls="programmes" aria-selected="false" style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Programmes & Clubs</a>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" >
                    <div class="tab-content">
                        <!-- <div class="tab-pane" id="parents_tab" aria-labelledby="parents_tab" > -->
                        <div class="tab-pane table-responsive  tab-pane active show fade" id="parents_tab" role="tabpanel" aria-labelledby="parents_tab-tab">
                            <strong style='font-weight: bold;font-family: "Times New Roman", Times, serif'><i class="fas fa-file-alt mr-1" ></i> Parents Details</strong>
                                <table class="table table-bordered table-striped">
                                <thead class="bg-info">
                                    <tr>
                                        <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Name</th>
                                        <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Relationship</th>
                                        <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Contact Number</th>
                                        <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Email</th>
                                        <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Working Address</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in parentsDetails" :key="index">
                                        <td>{{ item.Name}}</td>
                                        <td>{{ item.Relationship}}</td>
                                        <td>{{ item.ContactNo}}</td>
                                        <td>{{ item.Email}}</td>
                                        <td>{{ item.WorkAddress}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="tab-pane table-responsive " id="roles" aria-labelledby="roles-tab">
                            <strong style='font-weight: bold;font-family: "Times New Roman", Times, serif'><i class="fas fa-file-alt mr-1"></i> Roles & responsibility</strong>
                            <table class="table table-bordered table-striped">
                                <thead class="bg-info">
                                    <tr>
                                        <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Role</th>
                                        <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Created Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in roleDetails" :key="index">
                                        <td>{{ item.role_name}}</td>
                                        <td>{{ item.created_at}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="tab-pane table-responsive " id="programmes" aria-labelledby="programmes-tab">
                            <strong style='font-weight: bold;font-family: "Times New Roman", Times, serif'><i class="fas fa-file-alt mr-1"></i> Programmes & Clubs</strong>
                            <table class="table table-bordered table-striped">
                                <thead class="bg-info">
                                    <tr>
                                        <!-- <th>Programme</th> -->
                                        <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Name</th>
                                        <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Responsibility</th>
                                        <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Joining Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in programmeDetails" :key="index">
                                        <!-- <td>{{ item.CeaProgrammeId}}</td> -->
                                        <td>{{ item.program_name}}</td>
                                        <td>{{ item.Responsibility}}</td>
                                        <td>{{ item.JoiningDate}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
  data() {
    return {
      std_admission_details:[],
      is_student:false,
      user: "",
      cid:'',
      code:'',
      email:'',
      name:'',
      contact:'',
      type:'',
      parentsDetails:[],
      roleDetails:[],
      programmeDetails:[],
    };
  },
    methods:{
         getstudentPersonalDetails(type){
            axios.get('/admissions/getStudentDetailsFromPortal/'+type)
                .then(response => {
                let data = response.data;
                if(data != ""){
                    this.std_admission_details=data;
                }
            });
        },
         getStudentParentsDetails(id){
            axios.get('/admissions/getStudentParentsDetails/'+id)
                .then((response) => {
                    this.parentsDetails = response.data;
            })
            .catch(() => {
                consoele.log("Error:"+e)
            });
        },

        /**
         * Method to get programme details of the student
         */
        getStudentProgrammeDetails(id){
            axios.get('/admissions/getStudentProgrammeDetails/'+id)
                .then((response) => {
                    this.programmeDetails = response.data;
            })
            .catch(() => {
                consoele.log("Error:"+e)
            });
        },
        getStudentRoleDetails(id){
            axios.get('/admissions/getStudentRoleDetails/'+id)
                .then((response) => {
                    this.roleDetails = response.data;
            })
            .catch(() => {
                consoele.log("Error:"+e)
            });
        },
    },
    async mounted() {
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.cid=data['std_id'];
            this.code=data['std_code'];
            this.type=data['user_type'];
            this.getstudentPersonalDetails(this.type);
            this.getStudentParentsDetails(this.cid)
            this.getStudentProgrammeDetails(data['id'])
            this.getStudentRoleDetails(data['id'])
            this.email=data['email'];
            this.name=data['name'];
            this.contact=data['phone_number'];
            if(data['user_type']!="Parent" && data['user_type']!="Feedback" && data['user_type']!="Leadership" && data['user_type']!= 'Admin'){
                this.is_student=true;
            }
        })
        .catch(errors => {
            console.log(errors)
        });
    },
};
</script>
